module.exports = __webpack_public_path__ + "static/media/fjord.770ded44.jpg";